/**
 * Default: Components / Form (modify Shared)
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

import {extend} from '../../../../shared/utils/index';

import FormShared from '../../../../shared/components/form';

import SelectorEngine from '../../../../shared/dom/selector-engine';
import EventHandler from '../../../../shared/dom/event-handler';

// -------
// Private
// -------

/**
 * Automatisches Absenden des Eleternformulares bei Änderungen eines Formularelementes.
 * @param {Object} o
 * @returns Array
 */
const setupAutoSubmit = (o = {}) => {
	const _o         = extend({}, {
		timeout : 100
	}, o);
	const collection = SelectorEngine.find('[data-form-autosubmit]');

	if (collection.length) {
		for (const element of collection) {
			const form = SelectorEngine.parents(element, '.form');
			const type = element.getAttribute('type');

			let evName = (element.tagName.toLowerCase() === 'select') ? 'change' : '';

			if (!evName && type && ['radio', 'checkbox'].includes(type)) {
				evName = 'click';
			}

			if (evName && form[0]) {
				EventHandler.on(element, evName, () => {
					setTimeout(() => {
						if (element.tagName.toLowerCase() === 'select' && element.value.includes('/')) {
							location.href = element.value;
						} else {
							HTMLFormElement.prototype.submit.call(form[0]);
						}
					}, _o.timeout);
				});
			}
		}
	}

	return collection;
};

// ------
// Public
// ------

/**
 * Initialisierung.
 *
 * @param {Object} o
 * @returns Array
 */
const init = (o = {}) => {
	FormShared.init();

	setupAutoSubmit();
};

// Export
export default {
	init: init
};
